enum ViolationStatus {
  MISMATCH = "MISMATCH",
  MATCH = "MATCH",
  MISSING = "MISSING",
  OVERWRITTEN = "OVERWRITTEN",
  ALLOCATED = "ALLOCATED",
  EXEMPT = "EXEMPT",
  LOST = "LOST",
  APPROVED_LOST = "APPROVED_LOST",
}

export default ViolationStatus;
